import React, { Fragment, useEffect } from "react";
import Styles from "./style.module.scss";
import { BlogArticles } from "./components/BlogArticles";
import { useLocation } from "react-router-dom";
import JsonLd from "../../helpers/JsonLD";
import { MetaData } from "../../helpers/MetaData";
import { fetchBlogArticles, takeEraseArticleDetails } from "../../redux/Reducers/blogSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { markPrerenderError, markPrerenderReady, resetPrerenderStatus } from "../../utils/prerenderStatus";
import { IBlogArticle } from "../../types";
import PreLoader from "../../components/PreLoader/PreLoader";
import { RequestError } from "../../components/RequestError";
import { socialPreviews } from "../../utils/socialPreviews";

export const Blog: React.FC = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const { error, loading } = useAppSelector((state) => state.blog);

  const loadArchive = () => dispatch(fetchBlogArticles());

  const webPageDataBlog = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `https://alenalobacheva.com${pathname}#blog`,
    name: "Photography Archive | Alena Lobacheva Photography",
    description: "Selected stories from past photography sessions by Alena Lobacheva.",
    image: socialPreviews.blog.imageOG,
    url: `https://alenalobacheva.com${pathname}`,
    potentialAction: {
      "@type": "ReadAction",
    },
  };

  useEffect(() => {
    let active = true;
    resetPrerenderStatus("blog-archive");
    dispatch(
      takeEraseArticleDetails({
        title: "",
        url: "",
        imagePrev: "",
        typePhotoSession: "",
        // _id: "",
        createdAt: "",
        details: {
          images: [],
          description: "",
        },
      })
    );
    dispatch(fetchBlogArticles())
      .unwrap()
      .then((articles) => {
        if (!active) return;
        const hasArchiveStory = articles.some(
          (article: IBlogArticle) => article.url === "fall-session-in-fort-tryon-park-nyc"
        );
        hasArchiveStory ? markPrerenderReady("blog-archive") : markPrerenderError("blog-archive-empty");
      })
      .catch(() => active && markPrerenderError("blog-archive-request"));

    return () => {
      active = false;
    };
  }, [dispatch]);

  return (
    <Fragment>
      <JsonLd data={webPageDataBlog} />
      <MetaData
        title="Photography Archive | Alena Lobacheva Photography"
        description="Selected stories from past photography sessions by Alena Lobacheva."
        canonicalLink={`https://alenalobacheva.com${pathname}`}
        imageAltOG="blog photography"
        {...socialPreviews.blog}
        titleOG="Photography Archive | Alena Lobacheva Photography"
        descriptionOG="Selected stories from past photography sessions by Alena Lobacheva."
      />
      <div className={Styles.blog}>
        <h1 className={Styles.blog__title}>Photography Archive</h1>
        {loading.getBlog ? (
          <PreLoader />
        ) : error.getBlog ? (
          <RequestError message="We couldn’t load the photography archive." onRetry={loadArchive} />
        ) : (
          <BlogArticles />
        )}
      </div>
    </Fragment>
  );
};
